import React from "react";
import Games from "../components/Games";
import Filters from "../components/Filters";
import { useAtom } from "jotai";
import { categoriesAtom } from "../state/games";

const GamesPage = () => {
    const [categories] = useAtom(categoriesAtom);
    return (
        <>
            <Filters />
            {categories && <Games />}
        </>
    );
};

export default GamesPage;
